let en = {
  searchClient: "Search Client",
  submitBtn:"Submit",
  clientId:"Client Id",
  validations: {
    required: "{field} is required.",
    minLength: "Min length should be {length}.",
    maxLength: "Max length should be {length}.",
    minValue: "{field} can not be less than {value}",
    maxValue: "{field} can not be more than {value}",
    alpha: "{field} can only contain alphabets",
    alphaSpace: "{field} can only contain alphabets",
    alphaNum: "{field} can only contain alphabets and numbers.",
    numeric: "{field} can only be numeric",
    email: "{field} is not valid.",
    pan: "{field} is not valid.",
    mobile: "{field} is not valid.",
    date: "{field} is not valid.",
    aadhaar: "{field} is not valid.",
    minFileSize: "Minimum size of {field} should be {minSize}.",
    maxFileSize: "Maximum size of {field} should be {maxSize}.",
    fileType: "{field} can only be {types}.",
    sameAs: "{field} does not Match.",
    ifsc: "{field} is not valid.",
    valid: "{field} is not a valid input",
    
  }
};

export type language = typeof en;

export default en;
